import { Injectable } from '@angular/core';
import { SettingsService } from '../../settings/settings.service';

export interface Banco {
  id: string;
  name: string;
}

export interface Cuenta {
  id: string;
  name: string;
}

@Injectable({ providedIn: 'root' })
export class BankCatalogService {
  private bancos: Banco[] | null = null;
  private cuentas: Cuenta[] | null = null;
  private bancosPromise: Promise<Banco[]> | null = null;
  private cuentasPromise: Promise<Cuenta[]> | null = null;

  constructor(private settings: SettingsService) {}

  async getBancos(): Promise<Banco[]> {
    if (this.bancos) return this.bancos;
    if (this.bancosPromise) return this.bancosPromise;

    this.bancosPromise = this._fetchBancos();
    this.bancos = await this.bancosPromise;
    this.bancosPromise = null;
    return this.bancos;
  }

  async getCuentas(): Promise<Cuenta[]> {
    if (this.cuentas) return this.cuentas;
    if (this.cuentasPromise) return this.cuentasPromise;

    this.cuentasPromise = this._fetchCuentas();
    this.cuentas = await this.cuentasPromise;
    this.cuentasPromise = null;
    return this.cuentas;
  }

  private async _fetchBancos(): Promise<Banco[]> {
    const bd: any = await this.settings.get_query(1, '/cliente-inversionista/bank/');
    return bd._body.info.banks || [];
  }

  private async _fetchCuentas(): Promise<Cuenta[]> {
    const bd: any = await this.settings.get_query(1, '/cliente-inversionista/account-type/');
    return bd._body.info.accounts || [];
  }
}
